import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import { WeekDaysList } from "../weekDaysList/WeekDaysList";
import { EditScheduleModalItem } from "../scheduleRulesDialog/editRuleDialog";
import { RemoveScheduleModalItem } from "../scheduleRulesDialog/removeRuleDialog";
import { ScheduleActionsToggle } from "../scheduleRulesDialog/actionsDialog";
import { useSchedulerContext } from "../../../SchedulerContext";
import { ScheduleDuration } from "../../scheduleDuration/scheduleDuration";

import "./ScheduleRulesCards.scss";

const ScheduleRuleCard = ({ schedule }) => {
  const context = useSchedulerContext();

  const actionsItems = [
    <EditScheduleModalItem schedule={schedule} context={context} />,
    <RemoveScheduleModalItem schedule={schedule} />,
  ];

  return (
    <div className="schedule-rule-card">
      <div className="schedule-rule-card__time">
        <ScheduleDuration
          timeStart={schedule.timeStart}
          timeEnd={schedule.timeEnd}
          timeFormat={context.timeFormat24h}
        />
      </div>
      <div className="schedule-rule-card__actions">
        <ScheduleActionsToggle
          menuItems={actionsItems}
          header={<FormattedMessage id={"schedule_rule"} />}
        />
      </div>
      <div className="schedule-rule-card__days">
        <WeekDaysList days={schedule.day} type={schedule.type} />
      </div>
    </div>
  );
};

export const ScheduleRulesCards = ({ schedules }) => {
  if (_.isEmpty(schedules)) {
    return (
      <div className={"schedule-rule-card schedule-rule-card__empty"}>
        <FormattedMessage id="no_schedule_rules" />
      </div>
    );
  }
  return _.map(schedules, (schedule, index) => (
    <ScheduleRuleCard key={index} schedule={schedule} />
  ));
};
